import { useState, useEffect } from "react";

const navLinks = [
  { label: "Menu", href: "#menu" },
  { label: "Stop Here", href: "#stop-here" },
  { label: "Locations", href: "#locations" },
  { label: "Photos", href: "#photos" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#1A1A1A]/95 backdrop-blur-md shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-12 py-4 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/9087b38339b011a3e90dfeb23d2afa2c/249f0623333fea44c2b2bac063aaf7dc.jpeg"
            alt="Gallery Pizza Logo"
            className="w-12 h-12 rounded-full object-cover"
          />
          <div>
            <span className="text-[#FAF8F5] font-bold text-lg tracking-wide leading-none block">GALLERY</span>
            <span className="text-[#FF6B35] font-bold text-lg tracking-wide leading-none block">PIZZA</span>
          </div>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNav(link.href)}
              className="text-[#FAF8F5]/80 hover:text-[#FF6B35] text-sm font-medium tracking-widest uppercase transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
        </div>

        {/* Phone + CTA */}
        <div className="hidden md:flex items-center gap-4">
          <a href="tel:+3544878440" className="text-[#8B6F47] text-sm font-medium whitespace-nowrap">
            +354 487 8440
          </a>
          <a
            href="tel:+3544878440"
            className="bg-[#FF6B35] text-[#1A1A1A] text-sm font-bold px-5 py-2 rounded-full hover:bg-[#e55a24] transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Order Now
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-[#FAF8F5] cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={mobileOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-[#1A1A1A]/98 backdrop-blur-md px-6 pb-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNav(link.href)}
              className="text-[#FAF8F5]/80 hover:text-[#FF6B35] text-sm font-medium tracking-widest uppercase transition-colors duration-200 cursor-pointer text-left whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <a href="tel:+3544878440" className="text-[#8B6F47] text-sm font-medium whitespace-nowrap">
            +354 487 8440
          </a>
        </div>
      )}
    </nav>
  );
}
